module.exports = __webpack_public_path__ + "static/img/Maty-Ryan.8a6f0ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Maty-Ryan.jpg
// module id = 4pay
// module chunks = 0